import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { useToastProvider } from '@qualio/ui-components';
import { documentApi } from '../../../../../api/document';
import { PageOrientation } from '../../../../../api/model/document';

type DocumentOrientationProps = {
  documentId: number;
  orientation: PageOrientation;
  onSuccess?: () => void;
};

export const useUpdateOrientation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showToast } = useToastProvider();

  return useMutation({
    mutationFn: ({ documentId, orientation }: DocumentOrientationProps) =>
      documentApi.update({ orientation }, documentId),
    onError: (error) => {
      showToast({
        'data-cy': 'update-orientation-error-toast',
        id: 'update-orientation-error',
        status: 'error',
        title: t('notifications.error'),
        description: t('documentActions.failedToUpdateOrientation'),
        replace: true,
      });
    },
    onSuccess: (updateDocument, { onSuccess, documentId }) => {
      queryClient.setQueryData(
        ['newDocument', documentId.toString(), null],
        (oldDocument) =>
          oldDocument
            ? { ...oldDocument, orientation: updateDocument.orientation }
            : oldDocument,
      );
      if (onSuccess) {
        onSuccess();
      }
    },
  });
};
